module.exports = __webpack_public_path__ + "static/media/rigthrow.f86811d5.svg";